import { render, staticRenderFns } from "./store-campaign-details.vue?vue&type=template&id=4c5d53c2"
import script from "./store-campaign-details.vue?vue&type=script&lang=js"
export * from "./store-campaign-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports